<div class="flex flex-column gap-3 p-3"
     pDroppable="orders"
     (onDrop)="onDropToUnassign()">
  <!-- Date Navigation - Centered -->
  <div class="date-slider-sticky flex justify-content-center align-items-center mb-3">
    <div class="surface-card p-2 border-round shadow-1 flex align-items-center gap-2">
      <div class="relative p-2">
        <i class="pi pi-chevron-left cursor-pointer" (click)="previousDay()"></i>
        <span *ngIf="hasOrdersOnPreviousDay" class="indicator-dot" pTooltip="Orders available on previous day" tooltipPosition="top"></span>
      </div>
      <p-calendar styleClass="custom" [(ngModel)]="selectedDate" placeholder="Select Date" (onSelect)="onDateSelect()"></p-calendar>
      <div class="relative p-2">
        <i class="pi pi-chevron-right cursor-pointer" (click)="nextDay()"></i>
        <span *ngIf="hasOrdersOnNextDay" class="indicator-dot" pTooltip="Orders available on next day" tooltipPosition="top"></span>
      </div>
    </div>
  </div>

  <!-- Filter Options -->
  <p-toolbar styleClass="bg-gray-900 shadow-2"
    [style]="{ 'border-radius': '3rem', 'background-image': 'linear-gradient(to right, var(--surface-50), var(--surface-50))' }">
    <div class="card w-full">
      <!-- Header with label and button -->
      <div class="flex justify-content-center align-items-center gap-2">
        <span class="font-semibold flex align-items-center gap-3">
          <i class="pi pi-filter"></i>
          <span>Filter Options</span>
        </span>
        <p-button [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" (onClick)="toggleExpand()"
          styleClass="p-button-text p-button-sm" [pTooltip]="expanded ? 'Hide filters' : 'Show filters'">
        </p-button>
      </div>

      <!-- Expandable section with centered filters -->
      <div [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" class="overflow-hidden">
        <div class="flex flex-wrap gap-3 mt-3 justify-content-center" *ngIf="expanded">
          <div *ngFor="let loadType of Object.keys(groupedOrders)" class="flex align-items-center"
            style="min-width: fit-content;">
            <p-checkbox [(ngModel)]="selectedLoadTypes[loadType]" [label]="loadType" [name]="loadType"
              [value]="loadType" [binary]="true" />
          </div>
        </div>
      </div>
    </div>
  </p-toolbar>

  <!-- Unscheduled Orders Section - Only show if there are unscheduled orders -->
  <div *ngIf="unscheduledOrders.length > 0" class="surface-card p-3 border-round shadow-1 mb-3">
    <div class="flex justify-content-between align-items-center">
      <h5 class="m-0 font-medium flex align-items-center gap-2">
        <i class="pi pi-calendar"></i>
        Unscheduled Orders
        <p-badge [value]="unscheduledOrders.length.toString()" severity="info"></p-badge>
      </h5>
      <p-button [icon]="showUnscheduled ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
                (onClick)="toggleUnscheduled()"
                styleClass="p-button-text p-button-sm" 
                [pTooltip]="showUnscheduled ? 'Hide unscheduled orders' : 'Show unscheduled orders'">
      </p-button>
    </div>
    
    <!-- Divider when collapsed -->
    <p-divider *ngIf="!showUnscheduled" class="mt-2 mb-0"></p-divider>

    <!-- Expandable Content -->
    <div [@expandCollapse]="showUnscheduled ? 'expanded' : 'collapsed'" class="overflow-hidden">
      <div class="flex flex-wrap gap-3" *ngIf="showUnscheduled">
        <ng-container *ngFor="let group of groupedUnscheduledOrders | keyvalue">
          <!-- Customer Group Divider -->
          <div class="flex align-items-center gap-1 mt-2 mb-2 w-full">
            <div class="flex-grow-1">
              <p-divider align="center">
                <div class="flex align-items-center gap-2">
                  <p-button [icon]="isGroupCollapsed(group.key) ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
                  styleClass="p-button-text p-button-sm" 
                  [pTooltip]="isGroupCollapsed(group.key) ? 'Show orders' : 'Hide orders'"
                  (onClick)="toggleUnscheduledGroup(group.key)"></p-button>
                  <span class="font-bold">{{getUnscheduledGroupLabel(group.key)}}</span>
                  <span class="text-sm text-500">({{group.value.length}})</span>
                </div>
              </p-divider>
            </div>
          </div>

          <!-- Then conditionally show the orders -->
          <div *ngIf="!isGroupCollapsed(group.key)" class="w-full">
            <!-- Orders for this customer -->
            <div *ngFor="let order of group.value" 
                 class="p-4 border-round-xl relative cursor-move w-full shadow-1 hover:shadow-3 transition-all transition-duration-300 mb-2"
                 [class.cancelled]="order.load_status.toLowerCase() === 'cancelled'"
                 [style]="{
                   'border-left': '4px solid var(--orange-500)',
                   'transform-origin': 'center left',
                   'background-color': 'var(--surface-100)'
                 }"
                 [pDraggable]="order.load_status.toLowerCase() !== 'cancelled' ? 'orders' : undefined"
                 (onDragStart)="onDragStart($event,order)" 
                 (onDragEnd)="onDragEnd()"
                 >
              <div class="flex justify-content-between align-items-center">
                <div class="flex flex-column gap-2">
                  <span class="text-sm font-medium text-600">Receiver</span>
                  <span class="font-semibold text-900">{{getCustomerName(order.receiver_id)}}</span>
                </div>
                <div *ngIf="order.pickup_number" class="flex flex-column gap-2">
                  <span class="text-sm font-medium text-600">Pickup #</span>
                  <span class="font-semibold text-900">{{order.pickup_number}}</span>
                </div>
                <div *ngIf="order.pickup_date" class="flex flex-column gap-2">
                  <span class="text-sm font-medium text-600">Pickup Date</span>
                  <span class="font-semibold text-900">{{toCentralTime(order.pickup_date)}}</span>
                </div>
                <div *ngIf="order.delivery_date" class="flex flex-column gap-2">
                  <span class="text-sm font-medium text-600">Delivery Date</span>
                  <span class="font-semibold text-900">{{toCentralTime(order.delivery_date)}}</span>
                </div>
                <div *ngIf="order.notes" class="flex align-items-center">
                  <i class="pi pi-comment text-primary-500 cursor-pointer text-xl" 
                     pTooltip="{{order.notes}}"
                     tooltipPosition="left"></i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Empty State -->
        <div *ngIf="unscheduledOrders.length === 0" 
             class="w-full p-4 surface-ground border-round-xl text-center text-600">
          No unscheduled orders available
        </div>
      </div>
    </div>
  </div>

  <!-- Scheduled Orders Section -->
  <div class="surface-card p-3 border-round shadow-1">
    <div class="flex justify-content-between align-items-center">
        <h5 class="m-0 font-medium flex align-items-center gap-2">
            <i class="pi pi-calendar-times"></i>
            Scheduled Orders
            <p-badge [value]="availableOrders.length.toString()" severity="info"></p-badge>
        </h5>
        <p-button [icon]="showScheduled ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
                  (onClick)="toggleScheduled()"
                  styleClass="p-button-text p-button-sm" 
                  [pTooltip]="showScheduled ? 'Hide scheduled orders' : 'Show scheduled orders'">
        </p-button>
    </div>

    <!-- Expandable Content (default expanded) -->
    <div [@expandCollapse]="showScheduled ? 'expanded' : 'collapsed'" class="overflow-hidden">
        <div *ngIf="noMoreLoads && showScheduled" class="w-full p-4 surface-ground border-round-xl text-center text-600">
            No orders scheduled for {{selectedDate | date:'mediumDate'}}
        </div>
        
        <ng-container *ngFor="let group of getFilteredGroupedOrders() | keyvalue">
            <!-- Load Type Divider -->
            <div class="flex align-items-center gap-1 mt-2 mb-2">
                <div class="flex-grow-1">
                    <p-divider align="center">
                        <div class="flex align-items-center gap-2">
                            <span class="font-bold">{{group.key}}</span>
                            <span class="text-sm text-500">({{group.value.length}})</span>
                        </div>
                    </p-divider>
                </div>
            </div>

            <!-- Orders for this Load Type -->
            <div *ngFor="let order of group.value" 
                class="p-4 border-round-xl relative cursor-move w-full shadow-1 hover:shadow-3 transition-all transition-duration-300 mb-2"
                [class.cancelled]="order.load_status.toLowerCase() === 'cancelled'"
                [style]="{
                  'border-left': '4px solid var(--primary-500)',
                  'transform-origin': 'center left',
                  'background-color': 'var(--surface-100)'
                }"
                [pDraggable]="order.load_status.toLowerCase() !== 'cancelled' ? 'orders' : undefined"
                (onDragStart)="onDragStart($event,order)" 
                (onDragEnd)="onDragEnd()">
                <div class="flex justify-content-between align-items-center">
                    <div class="flex flex-column gap-2">
                        <span class="text-sm font-medium text-600">Shipper</span>
                        <span class="font-semibold text-900">{{getCustomerName(order.supplier_id)}}</span>
                        <span *ngIf="order.pickup_date" class="text-sm font-medium text-600">Pick Up</span>
                        <span *ngIf="order.pickup_date" class="font-semibold text-900">{{toCentralTime(order.pickup_date)}}</span>
                    </div>
                    <div class="flex flex-column gap-2">
                        <span class="text-sm font-medium text-600">Receiver</span>
                        <span class="font-semibold text-900">{{getCustomerName(order.receiver_id)}}</span>
                        <span class="text-sm font-medium text-600">Delivery</span>
                        <span *ngIf="order.delivery_date" class="font-semibold text-900">{{toCentralTime(order.delivery_date)}}</span>
                    </div>
                    <div *ngIf="order.pickup_number" class="flex flex-column gap-2">
                        <span class="text-sm font-medium text-600">Pickup #</span>
                        <span class="font-semibold text-900">{{order.pickup_number}}</span>
                    </div>
                    <div class="flex align-items-center gap-2">
                        <i *ngIf="order.notes" class="pi pi-comment text-primary-500 cursor-pointer text-xl" 
                           pTooltip="{{order.notes}}" tooltipPosition="left"></i>
                        <i *ngIf="order.pickup_driver_id !== order.delivery_driver_id" 
                           class="pi pi-share-alt text-yellow-600 text-lg"
                           [pTooltip]="getSplitLoadTooltip(order)" tooltipPosition="bottom"></i>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    
    <!-- Divider when closed -->
    <p-divider *ngIf="!showScheduled" class="mt-2 mb-0"></p-divider>
  </div>
</div>